export default {"src":"/_next/static/media/circle-solid-red.8b127f58.svg","height":512,"width":512};